import IcDelete from './IcDelete'

export default IcDelete
